import React, { useState, useRef } from 'react';

import Button from '../../../components/ui/Button';

const ChatInput = ({ onSendMessage, disabled = false, placeholder = "Digite sua mensagem..." }) => {
  const [message, setMessage] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const textareaRef = useRef(null);

  const handleSend = () => {
    if (!message?.trim() || disabled) return;
    
    onSendMessage(message?.trim());
    setMessage('');
    
    // Reset textarea height
    if (textareaRef?.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSend();
    }
  };

  const handleInputChange = (e) => {
    setMessage(e?.target?.value);
    
    // Auto-resize textarea
    if (textareaRef?.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef?.current?.scrollHeight, 120)}px`;
    }
  };

  const handleVoiceToggle = () => {
    setIsRecording(!isRecording);
    // Voice recording logic would go here
  };

  const suggestedQuestions = [
    "Como posso melhorar meu desempenho?",
    "Qual é o próximo tópico?",
    "Preciso de ajuda com esta atividade"
  ];

  return (
    <div className="border-t border-border bg-card">
      {/* Suggested Questions */}
      <div className="p-3 border-b border-border">
        <div className="flex flex-wrap gap-2">
          {suggestedQuestions?.map((question, index) => (
            <button
              key={index}
              onClick={() => setMessage(question)}
              className="px-3 py-1 text-xs bg-muted text-muted-foreground rounded-full hover:bg-accent hover:text-accent-foreground transition-micro"
            >
              {question}
            </button>
          ))}
        </div>
      </div>
      {/* Input Area */}
      <div className="p-4">
        <div className="flex items-end space-x-3">
          {/* Voice Input Button */}
          <Button
            variant={isRecording ? "default" : "ghost"}
            onClick={handleVoiceToggle}
            iconName={isRecording ? "MicOff" : "Mic"}
            iconSize={18}
            className="p-2 flex-shrink-0"
            title={isRecording ? "Parar gravação" : "Gravação de voz"}
          />

          {/* Text Input */}
          <div className="flex-1 relative">
            <textarea
              ref={textareaRef}
              value={message}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              placeholder={placeholder}
              disabled={disabled}
              className="w-full resize-none p-3 pr-12 border border-border rounded-lg bg-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-micro min-h-[44px] max-h-[120px]"
              rows={1}
            />
            
            {/* Character Counter */}
            <div className="absolute bottom-1 right-1 text-xs text-muted-foreground font-caption">
              {message?.length}/500
            </div>
          </div>

          {/* Send Button */}
          <Button
            onClick={handleSend}
            disabled={!message?.trim() || disabled}
            variant="default"
            iconName="Send"
            iconSize={18}
            className="p-3 flex-shrink-0"
            title="Enviar mensagem"
          />
        </div>

        {/* Recording Indicator */}
        {isRecording && (
          <div className="mt-2 flex items-center space-x-2 text-sm text-accent">
            <div className="w-2 h-2 bg-accent rounded-full animate-pulse" />
            <span>Gravando... Toque para parar</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatInput;